import http from "../../utils/http";
import { toast } from "../../utils/toast";

// 급여 항목 목록
export const getSalariesHistoriesList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/salaries/histories/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 급여 내역 등록
export const createSalariesHistories = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/salaries/histories", body)
      .then((res) => {
        toast.success('급여 내역이 등록되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 급여 내역 수정
export const modifySalariesHistories = (historyIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/salaries/histories/${historyIdx}`, body)
      .then((res) => {
        toast.success('급여 내역이 수정되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 급여 내역 삭제
export const deleteSalariesHistories = (historyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/salaries/histories/${historyIdx}`)
      .then((res) => {
        toast.success('급여 내역이 삭제되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 급여내역 Sample Excel 파일 다운로드 (더존/세무사랑)
export const getSalariesHistoriesSampleFiles = (type) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/salaries/histories/files/sample/${type}`, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 급여내역 Excel 엑셀 파일 다운로드
export const excelDownSalariesHistories = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/salaries/histories/list/files", body, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 급여내역 Excel 엑셀 파일 업로드
export const excelUploadSalariesHistories = (type, file) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/salaries/histories/files/${type}`, file)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


// 타솔루션 직원코드 등록 Excel 엑셀 파일 업로드
export const excelUploadEmployeeCode = (type, file) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/salaries/histories/employees/code/${type}`, file)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


// 급여내역 Excel 엑셀 파일 업로드 - 사업소득자
export const excelUploadSalariesHistoriesToBusiness = (type, file) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/salaries/histories/business/files/${type}`, file)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const bulkAdd = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/salaries/histories/bulk`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};